<template>
  <v-form ref="CharAcc">
    <v-container style="padding: 3% 3% 2% 3%;">
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="charAcc.name"
            label="Adı"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="charAcc.lastName"
            label="Soyadı"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="charAcc.email"
            label="Email"
            :rules="[rules.required, rules.email]"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="charAcc.chamber"
                style="padding:0"
                label="Oda"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="charAcc.regNo"
                style="padding:0"
                label="Sicil No"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model.number="charAcc.sealNo"
            label="Mühür Numarası"
            :rules="[rules.required, rules.isNumber]"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model.number="charAcc.tinNumber"
            label="Vergi Kimlik Numarası"
            :rules="[rules.required, rules.isNumber]"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="charAcc.taxOffice"
            label="Vergi Dairesi"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="charAcc.bureauAddress"
            label="Büro Adresi"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="charAcc.telephone"
            label="Telefon"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="charAcc.fax"
            label="Fax"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-menu
            ref="menu1"
            v-model="dateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="charAcc.contractDate"
                label="KDV İade Sözleşme Tarihi"
                persistent-hint
                v-bind="attrs"
                v-on="on"
                :rules="[rules.required]"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="charAcc.contractDate"
              no-title
              locale="tr-tr"
              @input="dateMenu = false"
              :rules="[rules.required]"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="charAcc.contractCount"
            label="KDV İade Sözleşme Sayısı"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
      </v-row>
      <hr style="margin 1% 0" />
      <v-btn color="blue darken-1" style="float: right;" text @click="save()">
        değişiklikleri kaydet
      </v-btn>
    </v-container>
  </v-form>
</template>

<script>
import * as userReq from '../../request/user.js'
export default {
  props: ["company", "popUpStatus"],
  name: "CharteredAccountant",
  data() {
    return {
      dateMenu: false,
      rules: {
        required: (value) => !!value || "Gerekli.",
        counter: (value) => value.length >= 5 || "En az 5 karakter",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Geçersiz Email";
        },
      },
      charAcc: {},
    };
  },
  watch: {
    popUpStatus() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      this.charAcc = { ...this.company.charteredAccountant };
    },
    save() {
      if(this.$refs.CharAcc.validate()) {
        userReq.updateCompanyProperty(this.company.id,'charteredAccountant', this.charAcc).then(res => {
          if(res.data.success) {
            this.$store.state.snackbarErrorObj = {
              snackbar: true,
              color: "success",
              text: "Kaydedildi",
              timeout: 1500,
            };
            let update = {}
            update.id = this.company.id
            update.value = this.charAcc
            this.$emit('refresh-company', 'charteredAccountant',update,)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  created() {
    this.loadData();
  },
};
</script>

<style></style>
